import * as ActionTypes from './actionTypes'
import {createActionObject} from '../../redux/utils'

export const changedTaskWorkflowStatus = (payload = {
    taskId: -1,
    workflowStatusId: -1,
    prevWorkflowStatusId: -1,
}) => {
    return createActionObject(ActionTypes.WORKFLOW_STATUS_CHANGED, payload)
}


// WEBPACK FOOTER //
// ./web/js/entities/tasks/actions.js